import { Box } from "@chakra-ui/react";
import { RouteMeta } from "@/components";
import { KNITTING_META } from "@/content";
import { DiscordCta, Footer, Nav, SkipLink } from "@/layout";
import {
  BackLink,
  KnitAlong,
  KnittingBasics,
  KnittingCta,
  KnittingHero,
  KnittingNeedles,
  KnittingOffMachine,
  KnittingPipeline,
  KnittingProgram,
  KnittingShaping,
} from "@/sections";

export const KnittingPage = () => (
  <>
    <RouteMeta meta={KNITTING_META} />
    <SkipLink />
    <Nav />
    <Box as="main" id="main">
      <KnittingHero />
      <KnitAlong />
      <KnittingOffMachine />
      <KnittingBasics />
      <KnittingNeedles />
      <KnittingShaping />
      <KnittingPipeline />
      <KnittingProgram />
      <KnittingCta />
      <BackLink />
      <DiscordCta />
    </Box>
    <Footer />
  </>
);
